import { render } from "./PriceHide.vue?vue&type=template&id=f7f90f4e"
import script from "./PriceHide.vue?vue&type=script&lang=js"
export * from "./PriceHide.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/app/components/PriceHide.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f7f90f4e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f7f90f4e', __exports__)) {
    api.reload('f7f90f4e', __exports__)
  }
  
  module.hot.accept("./PriceHide.vue?vue&type=template&id=f7f90f4e", () => {
    api.rerender('f7f90f4e', render)
  })

}


export default __exports__